import { Component, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-delinquent-diagnostic-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="📋 A student’s Diagnostic has been open for over 2 weeks"
      [preambles]="[{
        text: 'The student(s) below started a WordFlight Diagnostic more than two weeks ago and haven’t finished yet. '
          +  'Most students complete all seven levels in about 50–60 minutes total, or within one week. A quick check-in '
          + 'will help get them back on track.'
        }]"
      [steps]="steps"
      ctaLabel="Open Diagnostic Results"
      ctaRoute="/reports/system/diagnostic"
      closingText="They’ve got this — they just need a little push to finish strong!"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Diagnostic Started</th>
          <th class="th">Progress</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td" style="white-space:nowrap; color:#a2a2a2;">{{ notification.data.assessmentStartDate }}</td>
            <td class="td"><span class="badge-warn">In progress</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true
})
export class DelinquentDiagnosticNotificationComponent {
  readonly data = input.required<any>();
  readonly steps: NotificationStep[] = [
    {
      title: 'Check in with the student',
      body: 'Make sure they have enough time this week to complete the Diagnostic. Even one or two focused sessions should get them across the finish line.'
    },
    {
      title: 'Observe during their next session',
      body: 'Sit nearby to ensure they understand what to do and feel supported. Encourage them to keep going until they finish.'
    },
    {
      title: 'Track their progress',
      body: 'Open <b>Diagnostic Results</b> and select the Diagnostic they’re working on — their progress percentage will be listed. You’ll get a notification when they complete it.',
      variant: 'green',
    },
  ];
}
